// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Infrastructure
import { BillingAPI } from "views/Order/infrastructure";
// Components
import { FormControlLabel, Checkbox } from "@material-ui/core";
// Jquery
import $ from "jquery";
import { showNotify } from "../../../../vendor/application/disptach";

const Policy = (props) => {
  const { t, openPDF, plan } = props;
  return (
    <React.Fragment>
      <span>{t("billing:contract_01")}</span>
      <a className={`${plan}_a`} onClick={(e) => openPDF(e)}>
        {t("billing:contract_02")}
      </a>
      <span>{t("billing:contract_03")}</span>
    </React.Fragment>
  );
};

class Tab03 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contract: false,
      payment: ""
    };
  }

  openPDF = (e) => {
    e.preventDefault();

    window.open(
      `${process.env.REACT_APP_URL_BACKMANAGER}accounts/${this.props.data.user.account_id}/orders/${this.props.order_id}/contract`
    );

    this.actionHubspot("contract_downloaded");
  };

  handleActions = () => {
    this.putContract();
    this.getPaymentInfo();
  };

  getPaymentInfo = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(user.account_id, access, this.props, null);
      let res = await obj.get_payments_info(this.props.order_id);
      this.setState({ payment: res });
      setTimeout(() => {
        $("#payment_form").submit();
        this.actionHubspot("tpv_access");
      }, 500).bind(this);
    } catch (err) {}
  };

  putContract = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(user.account_id, access, this.props, null);
      await obj.put_contract(this.props.order_id);
    } catch (err) {}
  };

  acceptContract = (e) => {
    e.preventDefault();

    this.state.contract = !this.state.contract;

    this.setState({ contract: this.state.contract });
  };

  actionHubspot = async (event) => {
    const { user, access } = this.props.data;
    try {
      const obj = new BillingAPI(user.account_id, access, this.props, {
        event: event
      });
      await obj.hubspot(this.props.order_id);
    } catch (err) {}
  };

  showInfo = () => {
    var data = { from: "payment", type: "disabled", severity: "info" };
    this.props.dispatch(showNotify(data));
  };

  render() {
    const { t, handleTabs, tab, plan } = this.props;
    const { payment } = this.state;
    return (
      tab === 3 && (
        <React.Fragment>
          <div className="form-control">
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.contract}
                  onClick={(e) => {
                    this.acceptContract(e);
                  }}
                />
              }
              label={<Policy plan={plan} t={t} openPDF={this.openPDF} />}
            />
            {this.state.contract ? (
              <button
                onClick={() => this.handleActions()}
                className="btn btn-green"
              >
                {t("inputs:button.pay")}
              </button>
            ) : (
              <button
                onClick={() => this.showInfo()}
                className="btn btn-disabled"
              >
                {t("inputs:button.pay")}
              </button>
            )}
          </div>
          <div className="man-actions order">
            <span onClick={(e) => handleTabs(e, 2)}>
              {"< "}
              {t("inputs:button.back")}
            </span>
            {payment && (
              <form
                style={{ position: "absolute" }}
                action={`${payment.Ds_Redsys_Url}`}
                method="POST"
                id="payment_form"
              >
                <input
                  type="hidden"
                  name="Ds_SignatureVersion"
                  value={`${payment.Ds_SignatureVersion}`}
                />
                <input
                  type="hidden"
                  name="Ds_MerchantParameters"
                  value={`${payment.Ds_MerchantParameters}`}
                />
                <input
                  type="hidden"
                  name="Ds_Signature"
                  value={`${payment.Ds_Signature}`}
                />
                <input
                  style={{ visibility: "hidden" }}
                  type="submit"
                  value={`${t("inputs:button.pay")}`}
                />
              </form>
            )}
          </div>
        </React.Fragment>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_ = connect(mapStateToProps)(Tab03);
export default withTranslation(["order", "inputs", "billing"])(
  withRouter(connect_)
);
